export default function getEtatDemandeLogistique(demande) {
  if (demande.facesAffectees === demande.facesDemandees) {
    return 'demandeLogistique.patrimoine.etatDemande.affectee';
  }
  if (demande.facesAffectees > 0) {
    return 'demandeLogistique.patrimoine.etatDemande.affecteePatriellement';
  }
  return 'demandeLogistique.patrimoine.etatDemande.nonAffectee';
}
